var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (false)?_c('h1',[_vm._t("default",[_vm._v("请输入标题内容")])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }